// Videos List  ***************************************************************************************
// pathname: /v1/user/slug/videos
// ************************************************************************************************
import {
  GenericV1ErrorsArray,
  useSwrInfiniteApi,
} from '@hooks/useSwrApi';


// Interface
// ********************************************
interface JobListCardsInfiniteSwrProps {
  locale?: string;
  serverSideData?: ApiSchema<'ResumeStoriesResult'>;
  slug: string;
  shouldFetch?: boolean;
  errorCallback?: (errors: GenericV1ErrorsArray) => void,

}


/**
 * @description SWR: fetch job list cards with infinite pagination.
 *
 * * **locale**: string. What locale to use for the request.
 * * **serverSideData**: ResumeStoriesResult, optional. The data we got from the server side request (if we do it). Default undefined.
 * * **slug**: The card slug
 */
export const useSwrStoriesFetchSingle = (props: JobListCardsInfiniteSwrProps) => {
  // Props destructuring
  // ********************************************
  const {
    locale,
    serverSideData,
    slug,
    shouldFetch,
    errorCallback,
  } = props;


  // Get data from API
  // ********************************************
  const {
    data,
    error,
    size,
    setSize,
    isValidating,
    isLoading,
    mutate,
    isEmpty,
    showLoadMore,
    sizeAsRef,
  } = useSwrInfiniteApi<ApiSchema<'InterviewVideoRead2'>>({
    url: `/v1/user/${slug}/videos`,
    locale,
    serverSideData,
    infiniteConfig: {
    },
    shouldFetch,
    apiOptions: {
      keepPreviousData: true,
      revalidateOnFocus: false,
      dedupingInterval: 1000 * 60, // 1 minute
      onError: (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    size,
    setSize,
    isValidating,
    isLoading,
    mutate,
    isEmpty,
    showLoadMore,
    sizeAsRef,
  };
};
